import * as t from '../../actions/cafeteria/balance';

const initState = {
  result: 'none',
  transferSuccess: false,
  loading: false,
  err: '',
  data: {},
  students: {},
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case t.CAFETERIA_TRANSFER_CLEAR:
      return {
        ...state,
        transferSuccess: false,
      };

    case t.CAFETERIA_BALANCE_FAIL:
      return {
        ...state,
        err: action.payload.err,
        loading: false,
      };

    case t.CAFETERIA_BALANCE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case t.CAFETERIA_BALANCE_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };

    case t.CAFETERIA_TRANSFER_FAIL:
      return {
        ...state,
        err: action.payload.err,
        loading: false,
      };

    case t.CAFETERIA_TRANSFER_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case t.CAFETERIA_TRANSFER_SUCCESS:
      return {
        ...state,
        ...action.payload,
        transferSuccess: true,
        loading: false,
      };

    case t.CAFETERIA_BALANCE_CLEAR:
      return {
        ...state,
        result: 'none',
      };

    default:
      return state;
  }
}
